import { render, staticRenderFns } from "./ApprovalResearchSave.vue?vue&type=template&id=fc3549f2&"
import script from "./ApprovalResearchSave.vue?vue&type=script&lang=js&"
export * from "./ApprovalResearchSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports